export default "__VITE_ASSET__DSh1LztW__"